import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import AboutView from '@/views/AboutView.vue'
import ClientView from '@/views/ClientView.vue'
import CaseStudyHRMNYView from '@/views/CaseStudyHRMNYView.vue'
import CaseStudyDACRDView from '@/views/CaseStudyDACRDView.vue'
import FAQView from '@/views/FAQView.vue'
import ContactView from '@/views/ContactView.vue'
import MissionView from '@/views/MissionView.vue'
import LegalView from '@/views/LegalView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView
  },
  {
    path: '/clients',
    name: 'Clients',
    component: ClientView
  },
  {
    path: '/casestudy/dacrd',
    name: 'dacrd Case Study',
    component: CaseStudyDACRDView
  },
  {
    path: '/casestudy/hrmny',
    name: 'hrmny Case Study',
    component: CaseStudyHRMNYView
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: FAQView
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactView
  },
  {
    path: '/mission',
    name: 'Mission',
    component: MissionView
  },
  {
    path: '/legal',
    name: 'Legal',
    component: LegalView
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }
  }
})

export default router
